import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { TagGi } from '../models/tag-gi';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class TagGiService {


  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarTags(tipo: number) {
    return this.http.get<TagGi[]>(globals.apiUrl + '/api/Tag/Lista', {
      params: new HttpParams()
        .set('tipo', tipo.toString())
    });
  }

  consultarTagComPaginacao(tipo: number, descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipo', tipo.toString());

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Tag/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdTag(idTag) {
    return this.http.get<any>(globals.apiUrl + '/api/Tag/Buscar',
      { params: new HttpParams().set('id', idTag) });
  }

  salvar(tag: TagGi) {
    return this.http.post(globals.apiUrl + '/api/Tag/Salvar', tag);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Tag/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarPorIdCupom(idCupom, comLog) {
    let parametros = new HttpParams()
      .set('idCupom', idCupom);

    if (comLog) {
      parametros = parametros.set('comLog', comLog);
    }
    return this.http.get<any>(globals.apiUrl + '/api/Tag/ListarPorIdCupom',
      { params: parametros });
  }

  consultarPorIdIntegrador(idIntegrador) {
    return this.http.get<any>(globals.apiUrl + '/api/Tag/ListarPorIdIntegrador',
      { params: new HttpParams().set('idIntegrador', idIntegrador) });
  }
}
